import { IconButton, Typography } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { STRINGS } from "../config/strings";
import { usePermissions } from "../hooks/usePremissions";
import { useProviderSearchStore } from "../store/providerSearchStore";

import OutlinedButton from "./Buttons/OutlinedButton";
import SolidButton from "./Buttons/SolidButton";

export default function ButtonContainer() {
  const {
    handleOnClickCreateCustomProvider,
    handleOnClickAddProvider,
    disableSaveButton,
    assignedProvider,
    showMap,
    setShowMap,
    isProviderMapPage
  } = useProviderSearchStore();
  const {canAddProvider} = usePermissions();
  return (
    <div className={`flex flex-row items-end pb-2${!isProviderMapPage ? "gap-4" : ""}`}>
    <div className={`flex w-full flex-col ${!isProviderMapPage ? "gap-2" : ""}`}>
      <div className="relative flex w-[100%] flex-row justify-end">
        {!showMap && (
          <button
            id="map-visibility-btn"
            onClick={() => setShowMap(!showMap)}
            aria-label={"Show Map View"}
            className="z-50 flex items-center justify-center gap-2 rounded-[5.36px] bg-white px-2 py-1 shadow-md hover:bg-gray-100"
          >
            <Typography className="text-[14px]">
              {showMap ? STRINGS.BUTTON_LABELS.HIDE_MAP : STRINGS.BUTTON_LABELS.SHOW_MAP}
            </Typography>
            <IconButton
              className="rounded-[5.36px]"
              style={{ backgroundColor: HNSColors.primary[500] }}
            >
              <Svg
                name={showMap ? SvgEnum.HisEyeOff : SvgEnum.HisEye}
                color={HNSColors.neutrals[900]}
                sx={{ width: 20, height: 20 }}
              />
            </IconButton>
          </button>
        )}
      </div>
      {
      !isProviderMapPage ? 
      <div className={`flex flex-row justify-start gap-4 ${!showMap ? "w-3/5" : "w-full"}`}>
        {canAddProvider && <OutlinedButton
          className="w-1/2"
          onClick={handleOnClickCreateCustomProvider}
          label={STRINGS.BUTTON_LABELS.CREATE_NEW_PROVIDER}
        />
        }
        <SolidButton
          disabled={disableSaveButton}
          className="w-1/2"
          onClick={() => handleOnClickAddProvider(assignedProvider?.id)}
          label={STRINGS.BUTTON_LABELS.ADD_PROVIDER}
        />
      </div>
      :""
    }
    </div>
    </div>
  );
}
